import { useCurrentEnvironment } from '../../hooks/contexts';

import { getBackendBasePath } from '../../utils/getBackendBasePath';
import { getRedirectPath } from '../../utils/redirectToLogin';
import { getLogoByEnvName } from '../../utils/utils';

import styles from './Login.module.scss';

const LOCAL_DEV_ENV = 'local';
const DD_SECRET_COOKIE_NAME = 'dd-secret';

function isDatadogBrowserTest() {
    return document.cookie.includes(DD_SECRET_COOKIE_NAME);
}

function buildAuthUrl(path: string, redirectPath?: string): string {
    let url = `${getBackendBasePath()}${path}`;
    if (redirectPath) {
        url += `?redirectTo=${redirectPath}`;
    }
    return url;
}

function Login() {
    const { currentEnvName } = useCurrentEnvironment();

    const handleLogin = () => {
        const isDatadog = isDatadogBrowserTest();
        const isLocal = currentEnvName === LOCAL_DEV_ENV;
        const redirectPath = getRedirectPath();

        if (isLocal) {
            window.location.assign(
                buildAuthUrl('/api/v2/auth/dev', redirectPath),
            );
        } else if (isDatadog) {
            window.location.assign(
                buildAuthUrl('/api/v2/auth/datadog', redirectPath),
            );
        } else {
            window.location.assign(
                buildAuthUrl('/api/v2/auth/google', redirectPath),
            );
        }
    };

    return (
        <div tabIndex={0} className={styles.loginWrapper}>
            <div className={styles.centeredBlock}>
                <img
                    alt="tocaboca_logo"
                    className={styles.logoImg}
                    src={getLogoByEnvName(currentEnvName)}
                />

                <div className={styles.title}>Shop CMS</div>
                <div className={styles.buttonBlock}>
                    <button onClick={handleLogin}>Login with Google</button>
                </div>
            </div>
        </div>
    );
}

export default Login;
